/**
 * AiENSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AiENSiteHeaderLanguages
 */

import { useAiENSiteHeaderLanguagesLogic } from '@/hooks/traits/useAiENSiteHeaderLanguagesLogic';
import type { AiENSiteHeaderLanguagesConfig } from '@/hooks/traits/useAiENSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AiENAiView as AiENAiViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface AiENSiteHeaderLanguagesViewProps {
  config?: Partial<AiENSiteHeaderLanguagesConfig>;
}

export function AiENSiteHeaderLanguagesView({ config: propsConfig }: AiENSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAiENSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AiENAiView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AiEN" trait="AiENSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu className={((([{ href: "/ai" as const, code: "en" as const, label: "English" as const }, { href: "/ar/ai" as const, label: "العربية" as const, code: "ar" as const }, { label: "Slovenščina" as const, href: "/sl/ai" as const, code: "sl" as const }]).length === 0)) ? "hidden" : ""} items={Array.isArray(([{ code: "en" as const, label: "English" as const, href: "/ai" as const }, { label: "العربية" as const, href: "/ar/ai" as const, code: "ar" as const }, { href: "/sl/ai" as const, code: "sl" as const, label: "Slovenščina" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), href: (getNestedValue(entry, "href") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? "") }))) ? (((([{ code: "en" as const, label: "English" as const, href: "/ai" as const }, { label: "العربية" as const, href: "/ar/ai" as const, code: "ar" as const }, { href: "/sl/ai" as const, code: "sl" as const, label: "Slovenščina" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), href: (getNestedValue(entry, "href") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} position="bottom-end" trigger={<Button label={String(__locale.toUpperCase())} icon="globe" size="sm" variant="ghost" />} />) : null}
    </TraitScopeProvider>
  );
}

export default AiENSiteHeaderLanguagesView;
